<template>
    <div v-if="purchase.block_info">
        <p v-if="purchase.block_info.blocked_at" class="d-flex align-items-center text-danger fw-600 fs-12 my-2">Заблокировано {{ getDateTimeFormat(purchase.block_info.blocked_at) }}</p>
        <p v-if="purchase.block_info.message" class="d-flex align-items-center text-danger fw-600 fs-12 mt-2 mb-0">Причина блокировки:</p>
        <p v-if="purchase.block_info.message" class="d-flex align-items-center text-danger fs-12 my-0">{{ purchase.block_info.message }}</p>
    </div>
</template>
<script>
export default {
    name: 'cabinet-fl44-notice-card-block-info',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    }
};
</script>
